import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import cx from 'classnames';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import InputGroup from 'react-bootstrap/InputGroup';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';

import Link from '../../../Link';
import DatePicker from '../../../Common/DatePicker';
import Loader from '../../../Common/Loader';
import ImageUploadComponent from '../../../Common/ImageUploadComponent';

import validate from './validate';
import onSubmit from './submit';
import messages from '../../../../locale/messages';
import { normalizePromoCode } from './normalize';
import { api, promoCodeImageUploadDir } from '../../../../config';

import s from './PromoCodeForm.css';
import bt from '../../../../components/commonStyle.css';

export class PromoCodeForm extends Component {
	static defaultProps = {
		currency: 'USD',
		promoId: null,
		promoCurrency: 'USD',
		expiryDate: null
	}

	state = { load: true };

	componentDidUpdate(prevProps) {
		const { locale } = this.props.intl;
		const { locale: prevLocale } = prevProps.intl;

		if (locale !== prevLocale) {
			this.setState({ load: false });
			clearTimeout(this.loadSync);
			this.loadSync = null;
			this.loadSync = setTimeout(() => this.setState({ load: true }), 1);
		}
	}

	success = async (fileName) => {
		const { change } = this.props;
		await change('imageName', fileName);
	}

	renderField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, maxLength }) => {
		const { formatMessage } = this.props.intl;
		return (
			<Form.Group>
				<label className={bt.labelText} >{label}</label>
				<Form.Control {...input} placeholder={placeholder} type={type} className={bt.formControlInput} maxLength={maxLength} />
				{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	}

	renderFieldDiscount = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, promoType, promoCurrency }) => {
		const { formatMessage } = this.props.intl;
		return (
			<div className={cx('inputFormAddon', 'addonBorder')}>
				<Form.Group>
					<label className={bt.labelText} >{label}</label>
					<InputGroup>
						{
							promoType == 2 && <InputGroup.Append>
								<InputGroup.Text>
									{
										promoCurrency
									}
								</InputGroup.Text>
							</InputGroup.Append>
						}
						<Form.Control {...input} placeholder={placeholder} type={type} className={bt.formControlInput} />
						{
							promoType != 2 && <InputGroup.Append>
								<InputGroup.Text>%</InputGroup.Text>
							</InputGroup.Append>
						}
					</InputGroup>
					{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
				</Form.Group>
			</div>
		)
	}

	renderTextAreaField = ({ input, label, type, meta: { touched, error }, children, labelClass, fieldClass, placeholder, maxLength }) => {
		const { formatMessage } = this.props.intl;
		return (
			<Form.Group>
				<label className={bt.labelText} >{label}</label>
				<Form.Control as="textarea" rows="3" {...input} placeholder={placeholder} type={type} className={fieldClass} maxLength={maxLength} />
				{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	}

	render() {
		const { handleSubmit, currency, promoId, promoType, promoCurrency, expiryDate, loading, submitting, imageName, promoImageLoader } = this.props;
		const { formatMessage } = this.props.intl;
		const { load } = this.state;
		return (
			<div className={cx('cardSection', s.widthInner, bt.space5, s.responsiveNoPadding)}>
				<Row>
					<Col md={12} lg={12} sm={12} xs={12}>
						<h1 className={cx('textAlignRightRTL', s.headingTwo, 'textWhite')}>{promoId ? formatMessage(messages.editPromoCode) : formatMessage(messages.addPromoCode)}</h1>
						<div className={cx(s.singalCard, s.marbtm14)}>
							<div className={cx(s.profileImgSection, 'bgBlackTwo')}>
								<div className={'commonFilepicker'}>
									{
										load && <ImageUploadComponent
											className={cx(bt.btnPrimary, 'fileNoPadding', s.btnWidthadmin)}
											subTextClass={cx(s.subText, 'textWhiteTwo')}
											subText={formatMessage(messages.maximumUploadSizeLabel)}
											defaultMessage={formatMessage(messages.chooseFile)}
											postUrl={api.apiEndpoint + '/uploadPromoCodeImage'}
											handleDropzone={this.success}
											loaderName={'promoImageLoader'}
											loader={promoImageLoader}
											imageSrc={imageName ? api.apiEndpoint + promoCodeImageUploadDir + 'medium_' + imageName : null}
											fieldName={'imageName'}
											formName={'PromoCodeForm'}
											label={formatMessage(messages.promoCodeImage)}
											labelClass={cx(s.textAlignLeft, 'textAlignLeft', s.dropzoneLabelTitle)}
										/>
									}
									{!load && <Loader type={"text"} />}
								</div>
							</div>
						</div>
						<Card className={s.card}>

							<Form className={s.fullWidth} onSubmit={handleSubmit(onSubmit)}>
								<Row>
									<Col lg={6} md={12} sm={12} xs={12} className={bt.space2}>
										<Form.Group className={s.formGroup}>
											<div>
												<Field
													name="title"
													type="text"
													placeholder={formatMessage(messages.title)}
													component={this.renderField}
													label={formatMessage(messages.title)}
													labelClass={bt.labelText}
													fieldClass={bt.formControlInput}
												/>
											</div>
										</Form.Group>
									</Col>
									<Col lg={6} md={6} sm={6} xs={12} className={bt.space2}>
										<Form.Group className={s.formGroup}>
											<div>
												<Field
													name="description"
													type="text"
													placeholder={formatMessage(messages.description)}
													component={this.renderTextAreaField}
													label={formatMessage(messages.description)}
													labelClass={bt.labelText}
												/>
											</div>
										</Form.Group>
									</Col>
									<Col lg={6} md={6} sm={6} xs={12} className={bt.space2}>
										<Form.Group className={s.formGroup}>
											<div>
												<Field
													name="code"
													type="text"
													placeholder={formatMessage(messages.code)}
													component={this.renderField}
													label={formatMessage(messages.code)}
													labelClass={bt.labelText}
													fieldClass={bt.formControlInput}
													normalize={normalizePromoCode}
												/>
											</div>
										</Form.Group>
									</Col>
									<Col lg={6} md={6} sm={6} xs={12} className={bt.space2}>
										<Form.Group className={s.formGroup}>
											<div>
												<Field
													name="promoValue"
													type="text"
													placeholder={formatMessage(messages.discount)}
													component={this.renderFieldDiscount}
													label={formatMessage(messages.discount)}
													labelClass={bt.labelText}
													fieldClass={bt.formControlInput}
													promoType={promoType}
													promoCurrency={promoCurrency}
												/>
											</div>
										</Form.Group>
									</Col>

								</Row>
								<Row>
									{/* <Col lg={6} md={6} sm={6} xs={12} className={bt.space2}>
										<Form.Group className={s.formGroup}>
											<div>
												<label className={bt.labelText} >{formatMessage(messages.currency)}</label>
												<Field name="currency" className={cx(bt.formControlSelect, bt.formControlInput)} component="select">
													{
														currency && currency.availableCurrencies && currency.availableCurrencies.map(currency => (
															<option key={currency.id} value={currency.symbol}>{currency.symbol}</option>
														))
													}
												</Field>
											</div>
										</Form.Group>
									</Col> */}
									<Col lg={6} md={6} sm={6} xs={12} className={cx(bt.space2, 'promoDatePicker')}>
										<Form.Group className={s.formGroup}>
											<div>
												<label className={bt.labelText} >{formatMessage(messages.expireDate)}</label>
												<DatePicker
													placeholder={formatMessage(messages.expireDate)}
													formName={'PromoCodeForm'}
													fieldName={'expiryDate'}
													initialDate={expiryDate}
												/>
											</div>
										</Form.Group>
									</Col>
									{
										promoId && <Col lg={6} md={6} sm={6} xs={12} className={bt.space2}>
											<Form.Group className={s.formGroup}>
												<div>
													<label className={bt.labelText} >{formatMessage(messages.status)}</label>
													<Field name="isEnable" className={cx(bt.formControlSelect, bt.formControlInput)} component="select">
														<option value="true">{formatMessage(messages.active)}</option>
														<option value="false">{formatMessage(messages.inactive)}</option>
													</Field>
												</div>
											</Form.Group>
										</Col>
									}

								</Row>
								<div class="clearfix"></div>

								<div className={cx(bt.textAlignRight, bt.spaceTop3, 'textAlignLeftRTL', 'loadingBtnRTL')}>
									<Form.Group className={s.formGroup}>
										<div className={s.displayInlineBlock}>
											<Loader
												type={"button"}
												label={promoId ? formatMessage(messages.update) : formatMessage(messages.submitButton)}
												show={loading}
												buttonType={'submit'}
												className={cx(bt.btnPrimary)}
												disabled={submitting || loading}
												isSuffix={true}
											/>
										</div>
										<Link to={"/siteadmin/promo-code/list"} className={cx(s.backBtn, bt.btnSecondary, 'backBtnRTL', s.displayInlineBlock)} >{formatMessage(messages.goBack)}</Link>
									</Form.Group>
								</div>
							</Form>
						</Card>
					</Col>
				</Row>
			</div>
		)
	}
}

PromoCodeForm = reduxForm({
	form: 'PromoCodeForm',
	onSubmit,
	validate
})(PromoCodeForm);

const selector = formValueSelector('PromoCodeForm');
const mapState = state => ({
	currency: state.currency,
	promoId: selector(state, 'id'),
	promoType: selector(state, 'type'),
	promoCurrency: selector(state, 'currency'),
	expiryDate: selector(state, 'expiryDate'),
	loading: state.loader.AddPromoCode,
	imageName: selector(state, 'imageName'),
	promoImageLoader: state.loader.promoImageLoader
});

const mapDispatch = {};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(PromoCodeForm)));